import api from "..";
const unwrapItem = (data) => {
    if (!data || typeof data !== "object")
        return null;
    const record = data;
    if (record.item && typeof record.item === "object") {
        return record.item;
    }
    return record;
};
export const getList = async (page = 1, limit = 10, filters = {}) => {
    const params = { page, limit };
    if (filters.search)
        params.search = filters.search;
    if (filters.status)
        params.status = filters.status;
    if (filters.network !== undefined)
        params.network = filters.network;
    if (filters.sort)
        params.sort = filters.sort;
    const { data } = await api.get("/predict-instant/chosen", { params });
    if (data && typeof data === "object" && "packages" in data) {
        const response = data;
        return {
            totalPages: response.totalPages ?? 1,
            packages: Array.isArray(response.packages) ? response.packages : [],
        };
    }
    return {
        totalPages: 1,
        packages: Array.isArray(data) ? data : [],
    };
};
export const findRaw = (packageId) => api.get(`/predict-instant/chosen/${packageId}`).then((result) => {
    const unwrapped = unwrapItem(result.data?.item ?? result.data);
    if (!unwrapped)
        throw new Error("Package not found");
    return unwrapped;
});
